import { ReactNode, useMemo } from 'react';

import { SchemableFormVariablesContext } from './SchemableFormVariablesContext';

export const SchemableFormVariablesContextProvider = ({
  variables,
  children,
}: {
  variables: Record<string, string>;
  children: ReactNode;
}) => {
  const value = useMemo(() => ({ variables }), [variables]);

  return <SchemableFormVariablesContext.Provider value={value}>{children}</SchemableFormVariablesContext.Provider>;
};
